import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const PlannedActualCard = ({
  icon,
  title,
  planned,
  actual,
  color = "#0d9488",
  showIconCircle = true,
  className = "",
}) => (
  <div
    className={`pd-plan-card ${className}`.trim()}
    style={{ "--pd-accent": color }}
  >
    <div className="pd-plan-head">
      <span
        className={`pd-plan-icon${showIconCircle ? " pd-plan-icon-circle" : ""}`}
      >
        <FontAwesomeIcon icon={icon} />
      </span>
      <span className="pd-plan-title">{title}</span>
    </div>
    <div className="pd-plan-counts">
      <div>
        <small>Planned Count</small>
        <strong>{planned}</strong>
      </div>
      <div>
        <small>Actual Count</small>
        <strong>{actual}</strong>
      </div>
    </div>
  </div>
);

export default PlannedActualCard;
